module.exports = __webpack_public_path__ + "media/images/metal_black-960a2e63.png";